import axios from "axios";

// const API_URL = //'https://agrirent.softuvo.click/api/v1/admin/crops';
//                 //"http://localhost:5000/api/v1/admin/crops";
//                 "https://app.theshetu.com/api/v1/admin/crops";
const API_URL = `${process.env.REACT_APP_API_URL}/crops`;

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.accessToken) {
      config.headers.Authorization = `Bearer ${user.accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const getCropTypes = async (params) => {
  const response = await apiClient.get("/crop-types", { params });
  return response.data;
};

export const createCropType = async (data) => {
  let response;
  if (data instanceof FormData) {
    response = await apiClient.post("/crop-types", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  } else {
    response = await apiClient.post("/crop-types", data);
  }
  return response.data;
};

export const updateCropType = async (id, data) => {
  let response;
  if (data instanceof FormData) {
    response = await apiClient.put(`/crop-types/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  } else {
    response = await apiClient.put(`/crop-types/${id}`, data);
  }
  return response.data;
};

export const deleteCropType = async (id) => {
  const response = await apiClient.delete(`/crop-types/${id}`);
  return response.data;
};
